import React, { useEffect, useState } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles";
import { useSelector } from "react-redux";
const ThreeDropdownBirthdatePicker = ({ onDateChange, initialDate = null }) => {
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Select appropriate dropdown styles based on theme
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  const generateDays = (month, year) => {
    if (!month || !year) return [];
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: daysInMonth }, (_, i) => i + 1);
  };

  const months = Array.from({ length: 12 }, (_, i) => ({
    value: i + 1,
    label: new Date(0, i).toLocaleString("default", { month: "long" }),
  }));
  const handleDateChange = () => {
    if (day && month && year) {
      const birthDate = new Date(year, month - 1, day);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      onDateChange({
        date: birthDate,
        age: age,
        formattedDate: birthDate.toISOString().split("T")[0],
      });
    }
  };

  // Check if the current day is valid for the new month/year
  const validateCurrentDay = (newMonth, newYear) => {
    if (!day) return;

    const daysInNewMonth = new Date(newYear, newMonth, 0).getDate();
    if (day > daysInNewMonth) {
      setDay(""); // Reset day if it's invalid for new month/year
    }
  };

    const getMonthName = (monthNumber) => {
    return new Date(0, monthNumber - 1).toLocaleString('default', { month: 'long' });
  };

  useEffect(() => {
    if (initialDate instanceof Date && !isNaN(initialDate)) {
      const date = new Date(initialDate);
      setYear(date.getFullYear());
      setMonth(date.getMonth() + 1);
      setDay(date.getDate());
      handleDateChange();
    }
  }, [initialDate]);

  useEffect(() => {
    if (month && year) {
      validateCurrentDay(month, year);
      handleDateChange();
    }
  }, [month, year]);

  useEffect(() => {
    if (day && month && year) {
      handleDateChange();
    }
  }, [day]);

  return (
    <div className="three-dropdown-birthdate">
      <div className="row">
        <div className="col-4">
           
          <Select
            value={{ label: getMonthName(month), value: month }}
            onChange={(option) => {
              setMonth(option.value);
              validateCurrentDay(option.value, year);
            }}
            options={months}
            styles={dropdownStyles}
            placeholder={"Month"}
          />
        </div>
        <div className="col-4">
          <Select
            value={{ label: day, value: day }}
            onChange={(option) => {
              setDay(option.value);
            }}
            options={generateDays(month, year).map((d) => ({
              label: d,
              value: d,
            }))}
            styles={dropdownStyles}
            placeholder={"Day"}
          />
        </div>
        <div className="col-4">
          <Select
            value={{ label: year, value: year }}
            onChange={(option) => {
              setYear(option.value);
              validateCurrentDay(month, option.value);
            }}
            options={Array.from(
              { length: 121 },
              (_, i) => new Date().getFullYear() - i
            ).map((y) => ({ label: y, value: y }))}
            styles={dropdownStyles}
            placeholder={"Year"}
          />
        </div>
      </div>
    </div>
  );
};

export { ThreeDropdownBirthdatePicker };
